import React from 'react';
var getWidth = function (column, counts, defaultColumnWidth) {
    if (column.props.hidden && !column.props.width) {
        return defaultColumnWidth;
    }
    if (!column.props.width) {
        var computedWidth = parseFloat((counts.availWidth / counts.undefinedWidthColumns).toFixed(2));
        return computedWidth > defaultColumnWidth ? computedWidth : defaultColumnWidth;
    }
    return column.props.width;
};
var computeColumnsWidth = function (_a) {
    var columns = _a.columns, _b = _a.layoutWidth, layoutWidth = _b === void 0 ? 0 : _b, scrollbarWidth = _a.scrollbarWidth, hasVerticalScroll = _a.hasVerticalScroll, defaultColumnWidth = _a.defaultColumnWidth;
    var widthStore = {};
    var counts = {
        undefinedWidthColumns: 0,
        availWidth: hasVerticalScroll ? layoutWidth - scrollbarWidth : layoutWidth
    };
    React.Children.forEach(columns, function (column) {
        if (typeof column.props.width === 'number' && column.props.width && !column.props.hidden) {
            Object.assign(counts, {
                availWidth: counts.availWidth - column.props.width
            });
        }
        if (!column.props.width && !column.props.hidden) {
            Object.assign(counts, {
                undefinedWidthColumns: counts.undefinedWidthColumns + 1
            });
        }
    });
    React.Children.forEach(columns, function (column) {
        var _a;
        if (typeof column.key === 'string') {
            Object.assign(widthStore, (_a = {},
                _a[column.key] = getWidth(column, counts, defaultColumnWidth),
                _a));
        }
    });
    return widthStore;
};
export default computeColumnsWidth;
//# sourceMappingURL=computeColumnsWidth.js.map